<template>
	<div class="settings">
		<b-container class="bv-example-row">
			<b-card header-tag="header" footer-tag="footer">
				<div slot="header" class="top-card d-flex align-items-center justify-content-between">
					<span>
						<h5>{{ $t('sidebar.pos.cashboxCategory') }}</h5>
					</span>
					<b-button v-if="$can('create', 'cashbox')" variant="outline-info"
						@click.prevent="openCashboxCategoryModal({})">
						<i class="fa fa-plus" /> &nbsp;
						<span>{{ $t('client.addClient') }}</span>
					</b-button>
				</div>

				<b-table class="generalTableClass" hover="hover" striped="striped" bordered="bordered" small="small"
					fixed="fixed" :items="cashboxCategoryList" :fields="computedFields" show-empty>
					<template slot="empty">
						<h4>{{ $t('empty') }}</h4>
					</template>

					<template slot="id" slot-scope="data">
						<strong>{{ data.index + 1 }}</strong>
					</template>

					<template slot="childRefs" slot-scope="data" class="col-md-8">
						<b-link v-if="!$route.params.subRefCode3" :key="data.item.id" @click="childRefsLink(data.item)">
							{{ $t('sub-reference.title') }}
						</b-link>
					</template>

					<template slot="actions" slot-scope="data">
						<b-link v-if="$can('update', 'cashbox')" @click.prevent="openCashboxCategoryModal(data)">
							<i class="fa fa-pencil editBtn" />
						</b-link>
						<b-link v-if="$can('delete', 'cashbox')" :key="data.item.id + 'delete'"
							@click="onOpen(data.item.id)" :id="'popOverDelete' + data.item.id">
							<i class="fa fa-trash editBtn" />
						</b-link>
						<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
						<b-popover :key="data.item.id + 'popover'" :target="'popOverDelete' + data.item.id"
							placement="auto" container="myContainer" :ref="'popover' + data.item.id"
							class="refDeleteConfirm">
							<template slot="title">
								<b-button @click="onClose(data.item.id)" class="close" aria-label="Close"
									style="margin-left: 5px">
									<span class="d-inline-block" aria-hidden="true">&times;</span>
								</b-button>
								{{ $t('actions.deletetitle') }}
							</template>

							<div>
								<div class="row mt-1">
									<div class="col-6">
										<b-button variant="outline-danger" size="sm" block
											@click="onClose(data.item.id)">{{
												$t('actions.no') }}
										</b-button>
									</div>
									<div class="col-6">
										<b-button variant="outline-success" size="sm" block
											@click="deleteCashboxCategory(data.item.id)">{{
												$t('actions.yes') }}
										</b-button>
									</div>
								</div>
							</div>
						</b-popover>
					</template>
				</b-table>

				<!--		MODAL FOR ADDING/EDITING CASHBOX		-->
				<b-modal body-class="refModal subReferenceModal" ref="updateRefModal" @shown="focusMyElement"
					hide-footer ok-title="Save"
					:title="modalForAdding ? $t('reference.create.title') : $t('reference.update-title')">
					<div>
						<p v-if="refInputNotFilled" style="color: red;">{{ $t('please-title') }}</p>

						<b-form-group label-cols="4" label-cols-lg="3" label-size="sm"
							:label="$t('reference.create.name')" label-for="refName" class="required">
							<b-form-input :required="true"
								data-errormessage-value-missing="Это поле обязательно для заполнения!" id="childRefName"
								size="sm" v-model="editingItem.name" autofocus="" ref="childRefNameRef"
								:placeholder="$t('reference.create.name')" />
						</b-form-group>

						<div class="row mt-3 createRoleModalButtons justify-content-end">
							<div class="col-4">
								<b-button variant="outline-danger" size="sm" block @click="closeCashboxCategoryModal">
									{{ $t('actions.cancel') }}
								</b-button>
							</div>
							<div class="col-4">
								<b-button variant="outline-success" size="sm" block @click="addNewCashboxCategory">
									{{ $t('actions.save') }}
								</b-button>
							</div>
						</div>
					</div>
				</b-modal>
			</b-card>
		</b-container>
	</div>
</template>

<script>
import ApiService from "@/services/api.service";
import Multiselect from 'vue-multiselect'

const itemInitial = {
	name: null,
	status: null
};
export default {
	components: {
		Multiselect
	},
	data() {
		return {
			cashboxCategoryList: [],
			refInputNotFilled: false,
			refInputNotFilled: false,
			modalForAdding: false,
			editingItem: Object.assign({}, itemInitial),
			fields: [
				{
					key: "id",
					label: "#",
					class: "role_id",
				},
				{
					key: "name",
					label: this.$t("reference.name"),
				},
				{
					key: 'childRefs',
					label: this.$t('reference.child')
				},
				{
					key: "actions",
					label: this.$t("employees.actions"),
					class: "table_actions",
					sortable: true
				},
			],
			cashboxCategorynumber: '',
			show: false,
			errorShow: false,
			cashboxCategoryId: null,
			savedCashboxCategoryId: null,
		}
	},
	async created() {
		await this.fetchCashboxCategoryList()
	},
	computed: {
		computedFields() {
			return this.fields
		},
	},
	methods: {
		async childRefsLink(item) {
			this.$router.push({ name: 'CashboxCategoryItem', params: { id: item.id } })
		},
		onOpen(itemId) {
			let refName = 'popover' + itemId;
			this.$refs[refName].$emit('open')
		},
		onClose(itemId) {
			let refName = 'popover' + itemId;
			this.$refs[refName].$emit('close')
		},
		async deleteCashboxCategory(itemId) {
			ApiService.delete(`cashbox-category/delete/${itemId}`)
				.then(res => {
					this.fetchCashboxCategoryList()
				})
		},
		/* POPOVER METHODS END */
		closeCashboxCategoryModal() {
			this.refInputNotFilled = false;
			this.$refs.updateRefModal.hide();
		},
		openCashboxCategoryModal(data) {
			this.refInputNotFilled = false;
			if (data.item) {
				this.modalForAdding = false;
				this.editingItem.id = data.item.id;
				this.editingItem.name = data.item.name;
				this.$refs.updateRefModal.show();
			} else {
				this.editingItem = Object.assign({}, itemInitial);
				this.modalForAdding = true;
				this.$refs.updateRefModal.show();
			}
		},
		focusMyElement() {
			this.$refs.childRefNameRef.focus();
		},
		fetchCashboxCategoryList(fetchAndUpdate = false) {
			ApiService.get(`cashbox-category/list-search?search`)
				.then(res => {
					this.cashboxCategoryList = res.data
					this.closeCashboxCategoryModal()
				})
		},
		addNewCashboxCategory() {
			if (this.editingItem.name.trim() != '') {
				this.refInputNotFilled = false
				if (this.modalForAdding)
					ApiService.post(`cashbox-category/create`, this.editingItem)
						.then(res => {
							this.fetchCashboxCategoryList()
						})
				else
					ApiService.put(`cashbox-category/update/${this.editingItem.id}`, this.editingItem)
						.then(res => {
							this.fetchCashboxCategoryList(true)
						})
			} else {
				this.refInputNotFilled = true
			}
		},
	}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.btn-frame {
	display: flex;
	justify-content: flex-end;
	margin-top: 10px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	/* display: none; <- Crashes Chrome on hover */
	-webkit-appearance: none;
	margin: 0;
	/* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
	-moz-appearance: textfield;
	/* Firefox */
}

.editBtn {
	font-size: 14px;
	cursor: pointer;
}

.cashbox {
	display: flex;
	justify-content: center;
}

.cashboxnumber {
	font-size: 20px;
	margin-bottom: 4px;
	margin-left: 10px;
}

.success-save {
	display: flex;
	justify-content: center;
	padding: 8px;
}
</style>
